'use client'

import NiceModal from '@ebay/nice-modal-react'
import { ThemeProvider } from 'next-themes'
import * as React from 'react'
// import { NuqsAdapter } from 'nuqs/adapters/next/app';
import { TooltipProvider } from '@/components/ui/tooltip'
// import { createChat } from '@n8n/chat'
import '@n8n/chat/style.css'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
export function Providers({ children }: React.PropsWithChildren): React.JSX.Element {
  const queryClient = new QueryClient()
  // React.useEffect(() => {
  //   createChat({
  //     webhookUrl:
  //       'https://rebbeca-unbenign-jolie.ngrok-free.dev/webhook/23ae8376-305f-48e7-b2e4-cb3e7bdb8487/chat',
  //     initialMessages: ['Hi there! 👋', 'My name is PioneAI. How can I assist you today?'],
  //     defaultLanguage: 'en',
  //     i18n: {
  //       en: {
  //         message: '',
  //         title: 'Hi there! 👋',
  //         subtitle: "Start a chat. We're here to help you 24/7.",
  //         footer: '',
  //         getStarted: 'New Conversation',
  //         inputPlaceholder: 'Type your question..',
  //         closeButtonTooltip: 'Close'
  //       }
  //     }
  //   })
  // }, [])
  return (
    // <NuqsAdapter>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider attribute='class' defaultTheme='system' enableSystem disableTransitionOnChange>
        <TooltipProvider>
          <NiceModal.Provider>{children}</NiceModal.Provider>
        </TooltipProvider>
      </ThemeProvider>
    </QueryClientProvider>
    // </NuqsAdapter>
  )
}
